import { motion } from "framer-motion";

const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.2,
    },
  },
};

const cardVariants = {
  hidden: { opacity: 0, y: 40 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: "easeOut" },
  },
};

const BlockDiferencial = ({ diferencia1, diferencia2, diferencia3 }) => {

    const processContent = (html) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");

    doc.querySelectorAll("img").forEach((img) => {
      const src = img.getAttribute("src");

      if (src && !src.startsWith("http")) {
        img.setAttribute(
          "src",
          `https://be-ofertas.utpl.edu.ec/${src.replace(/^\/+/, "")}`,
        );
      }
    });

    return doc.body.innerHTML;
  };
  
  // Guardamos las props en un array de configuración limpia
  const cards = [
    { key: "dif1", content: diferencia1 },
    { key: "dif2", content: diferencia2 },
    { key: "dif3", content: diferencia3 },
  ];

  // Si no se pasa la primera diferencia (o ninguna), no se renderiza el bloque
  if (!diferencia1) return null;

  return (
    <section className="bg-[#004270] py-24">
      <div className="max-w-7xl mx-auto px-6">
        {/* Título */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: false }}
          transition={{ duration: 0.6 }}
          className="text-center mb-14"
        >
          <span className="uppercase text-amber-400  ">Diferenciales</span>
          <h2 className="font-bold text-white  ">¿Qué nos diferencia?</h2>
        </motion.div>

        {/* Cards */}
        <motion.div
          className="grid gap-8 md:grid-cols-3"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: false }}
        >
          {cards.map(({ key, content }) => {
            if (!content) return null;

            return (
              <motion.div
                key={key}
                variants={cardVariants}
                className="rounded-3xl border border-white/15 bg-white/8 p-8 text-white"
              >
                <div className="[&_img]:max-h-[120px] [&_img]:w-auto [&_img]:m-auto [&_img]:mb-6 [&_p]:text-slate-200 [&_strong]:text-white [&_ul]:space-y-3 [&_li]:text-slate-200">
                  {content}
                </div>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
};

export default BlockDiferencial;
